document.addEventListener('DOMContentLoaded', () => {
	const expandables = document.querySelectorAll<HTMLElement>('.js-expandable');
	const focusableSel = 'a[href], button:not([disabled])';

	expandables.forEach((exp) => {
		const trigger = exp.querySelector<HTMLButtonElement>('.js-expandable-trigger');
		const content = exp.querySelector<HTMLElement>('.js-expandable-content');
		if (!trigger || !content) {
			return;
		}

		if (!content.id) {
			content.id = `exp-${Math.random().toString(36).slice(2, 9)}`;
		}
		trigger.setAttribute('aria-controls', content.id);

		const isInitiallyOpen = exp.classList.contains('is-open');
		trigger.setAttribute('aria-expanded', String(isInitiallyOpen));
		setPanelState(content, isInitiallyOpen);

		trigger.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault(); // Add this to prevent any default behavior

			const isOpen = exp.classList.contains('is-open');

			// Close siblings at the same level
			const siblings = Array.from(exp.parentElement?.children || []).filter(
				(el) => el !== exp && el.classList.contains('js-expandable')
			);

			siblings.forEach((other) => {
				other.classList.remove('is-open');
				const t = other.querySelector<HTMLButtonElement>('.js-expandable-trigger');
				const c = other.querySelector<HTMLElement>('.js-expandable-content');
				if (t) {
					t.setAttribute('aria-expanded', 'false');
				}
				if (c) {
					setPanelState(c, false);
				}
			});

			// Toggle the clicked accordion
			if (!isOpen) {
				exp.classList.add('is-open');
				trigger.setAttribute('aria-expanded', 'true');
				setPanelState(content, true);

				// Only focus first element if it's NOT another expandable trigger
				const first = content.querySelector<HTMLElement>(focusableSel);
				if (first && !first.classList.contains('js-expandable-trigger')) {
					first.focus();
				}
			} else {
				exp.classList.remove('is-open');
				trigger.setAttribute('aria-expanded', 'false');
				setPanelState(content, false);
			}
		});
	});

	function setPanelState(content: HTMLElement, open: boolean) {
		if (open) {
			content.removeAttribute('inert');
			content.removeAttribute('aria-hidden');
		} else {
			content.setAttribute('inert', '');
			content.setAttribute('aria-hidden', 'true');
		}
	}
});
